function Footer() {
  return (
    <footer className="login-footer">
      <p>© {new Date().getFullYear()} Anteeo. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
